module.exports = __webpack_public_path__ + "img/jon_smith_6.a8d842b9.png";